import type { ModuleVersionMap } from './types';

export const BUNDLED_VERSION_MAP: ModuleVersionMap = {
  version: 1,
  updatedAt: '2026-06-26T00:00:00.000Z',
  modules: {
    'tenant-web-workspace': {
      current: import.meta.env.DEV
        ? 'http://127.0.0.1:8013/mf-manifest.json?version=1.0.0'
        : '/remotes/workspace/mf-manifest.json?version=1.0.0',
      previous: 'local:tenant-web-workspace@0.9.0',
    },
    'tenant-web-admin': {
      current: import.meta.env.DEV
        ? 'http://127.0.0.1:8014/mf-manifest.json?version=1.0.0'
        : '/remotes/admin/mf-manifest.json?version=1.0.0',
      previous: 'local:tenant-web-admin@0.9.0',
    },
    'tenant-web-hr-workspace': {
      current: import.meta.env.DEV
        ? 'http://127.0.0.1:8015/mf-manifest.json?version=1.0.0'
        : '/remotes/hr/workspace/mf-manifest.json?version=1.0.0',
      previous: 'local:tenant-web-hr-workspace@0.9.0',
    },
    'tenant-web-hr-admin': {
      current: import.meta.env.DEV
        ? 'http://127.0.0.1:8016/mf-manifest.json?version=1.0.0'
        : '/remotes/hr/admin/mf-manifest.json?version=1.0.0',
      previous: 'local:tenant-web-hr-admin@0.9.0',
    },
  },
};
